<template>
  <v-row justify="center">
    <v-dialog
      v-model="cellPhoneUpdateActive"
      persistent
      max-width="400"
      v-if="currentUser"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("card.update cellphone") }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <table class="cellphone-table">
                <tr>
                  <td width="120px">{{ $t("label.name") }}</td>
                  <td width="10px" class="text-center">:</td>
                  <td>{{ currentUser.nama }}</td>
                </tr>
                <tr>
                  <td width="120px">{{ $t("label.cellphone") }}</td>
                  <td width="10px" class="text-center">:</td>
                  <td>
                    <div class="cellphone-column">
                      <span>+62</span>
                      <input
                        v-model="form.cellphone"
                        type="text"
                        class="phone-number-input"
                      />
                    </div>
                  </td>
                </tr>
                <tr v-if="$v.form.cellphone.$error">
                  <td colspan="3" style="color: red; text-align: right">
                    <small v-if="$v.form.cellphone.$error">
                      <span v-if="!$v.form.cellphone.required"
                        >{{$t('error.cellphone is required')}}</span
                      >
                      <span v-else-if="!$v.form.cellphone.indoPhoneLocal">
                        {{$t('error.indonesian cellphone format')}}
                      </span>
                    </small>
                  </td>
                </tr>
                <tr>
                  <td width="120px">{{ $t("label.request token") }}</td>
                  <td width="10px" class="text-center">:</td>
                  <td style="text-align: right">
                    <v-btn
                      color="primary"
                      :disabled="tokenCountDown > 0"
                      class="token--button"
                      outlined
                      @click="tryToken"
                    >
                      <v-icon class="mr-2" v-if="!tokenCountDown">
                        {{ iconWA }}
                      </v-icon>
                      <v-icon class="mr-2" v-else>
                        {{ iconTimer }}
                      </v-icon>
                      {{
                        !tokenCountDown
                          ? $t("button.request-token-wa")
                          : `${$t("text.wait-for")} ${tokenCountDown} ${$t(
                              "text.seconds"
                            )}`
                      }}
                    </v-btn>
                  </td>
                </tr>
                <tr>
                  <td width="120px">{{ $t("label.whatsapp token") }}</td>
                  <td width="10px" class="text-center">:</td>
                  <td>
                    <input
                      v-model="form.token"
                      type="text"
                      class="phone-number-input"
                    />
                  </td>
                </tr>
                <tr v-if="$v.form.token.$error">
                  <td colspan="3" style="color: red; text-align: right">
                    <small v-if="$v.form.token.$error">
                      <span v-if="!$v.form.token.required">{{
                        $t("error.token-is-required")
                      }}</span>
                      <span v-if="!$v.form.token.fourDigits">{{
                        $t("error.token is four digit number")
                      }}</span>
                    </small>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text @click="submit">
            <v-icon class="mr-2">
              {{ iconSave }}
            </v-icon>
            {{ $t("button.update") }}
          </v-btn>
          <v-btn color="green darken-1" outlined text @click="closeMe">
            {{ $t("button.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState } from "vuex";
// import { mdiAlertCircleOutline, mdiClose, mdiTransfer } from "@mdi/js";
import { mdiTimerSand, mdiWhatsapp, mdiContentSaveCheck, mdiCheck } from "@mdi/js";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { indoPhoneLocal, fourDigits } from "./helper.js";
import { http } from "@/http/http";
export default {
  mixins: [validationMixin],
  props: {
    cellPhoneUpdateActive: Boolean,
    elemenPic: [Object, String],
  },
  data: () => ({
    iconTimer: mdiTimerSand,
    iconWA: mdiWhatsapp,
    iconSave: mdiContentSaveCheck,
    iconCheck: mdiCheck,
    tokenCountDown: 0,
    _tokenTimer: null,
    form: {
      cellphone: undefined,
      token: undefined,
    },
  }),
  validations: {
    form: {
      cellphone: {
        required,
        indoPhoneLocal,
      },
      token: { required, fourDigits },
    },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },
  mounted() {
    this._hydrateTokenCountdown();
  },

  beforeDestroy() {
    this._clearTokenTimer();
  },
  computed: {
    ...mapState(["currentLanguage"]),
    ...mapState("user", ["currentUser"]),
  },
  methods: {
    async tryToken() {
      this.$v.form.cellphone.$touch();
      if (this.$v.form.cellphone.$anyError) return;
      this.startTokenCountdown();

      let formData = new FormData;
      formData.append ('cellphone', `+62${this.form.cellphone}`)
      formData.append('scope', "updatecellphone")
      formData.append('via', "whatsapp")

       try {
        const response = await http.post(
          `references/update-cellphone-token`, formData
        );
        if (response && response.status == "success") {
         this.$dialog.info({
              text: this.$t("msgbox.check your whatsapp"),
              title: this.$t("msgbox.request token"),
              persistent: true,
              actions: [
                {
                  text: this.$t("button.ok"),
                  color: "success",
                  key: false,
                  icon: mdiCheck,
                },
              ],
            });
           
        }
      } catch (error) {
        console.log('ada error')
        console.error(error);
        this._clearTokenTimer();
        localStorage.removeItem("tokenCountdownExpiresAt");
        this.tokenCountDown = 0;
      }

    },
    getSmsToken({ cellphone, scope, via }) {
      console.log(cellphone, scope, via);
    },
    closeMe() {
      this.$v.$reset();
      this.$emit("closeUpdateCellPhone", false);
    },
    isSecretary(val) {
      let retVal = "False";
      if (!val) {
        this.currentLanguage == "id" ? (retVal = "Bukan") : (retVal = "No");
      } else {
        this.currentLanguage == "id" ? (retVal = "Ya") : (retVal = "Yes");
      }
      return retVal;
    },
    parseElemen(val) {
      let result = "STAFSUBAG/ASISTEN";
      switch (val) {
        case "KARPIM":
        case "KARPIM_KANPUS":
          result = "STAFSUBAG/ASISTEN";
          break;
        case "KASUBAG":
          result = "KASUBAG/KABID/KASUBDIV/ASKEP/MASKEP";
          break;
        case "PJP":
        case "PJP_KANPUS":
          result = "KABAG/KADIV/MANAGER";
          break;
        case "DIREKTUR":
          result = "DIREKTUR/SEVP";
          break;
        case "KOMISARIS":
          result = "DIREKTUR/SEVP/KOMISARIS";
          break;
        default:
          break;
      }
      return result;
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.form.$anyError) return;
      let formData = new FormData;
      formData.append ('cellphone', `+62${this.form.cellphone}`)
      formData.append('token', this.form.token)
       try {
        const response = await http.post(
          `references/update-cellphone`, formData
        );
        if (response && response.status == "success") {
         this.$dialog.info({
              text: this.$t("msgbox.cellphone number is updated successfully"),
              title: this.$t("msgbox.cellphone updated"),
              persistent: true,
              actions: [
                {
                  text: this.$t("button.ok"),
                  color: "success",
                  key: false,
                  icon: mdiCheck,
                },
              ],
            });
             this.closeMe()
        }
      } catch (error) {
        this._clearTokenTimer();
        localStorage.removeItem("tokenCountdownExpiresAt");
        this.tokenCountDown = 0;
      }
    },
    startTokenCountdown() {
      const DURATION = 60; // detik
      const expiresAt = Date.now() + DURATION * 1000;

      localStorage.setItem("tokenCountdownExpiresAt", String(expiresAt));
      this.tokenCountDown = DURATION;

      this._startTokenTicker();
    },

    // Baca sisa waktu dari localStorage saat halaman dimuat/refresh
    _hydrateTokenCountdown() {
      const raw = localStorage.getItem("tokenCountdownExpiresAt");
      const expiresAt = raw ? Number(raw) : 0;

      if (expiresAt > Date.now()) {
        this.tokenCountDown = Math.ceil((expiresAt - Date.now()) / 1000);
        this._startTokenTicker();
      } else {
        this.tokenCountDown = 0;
        localStorage.removeItem("tokenCountdownExpiresAt");
      }
    },

    // Jalankan interval; hitung sisa waktu dari timestamp (anti drift)
    _startTokenTicker() {
      this._clearTokenTimer(); // pastikan tidak dobel interval

      this._tokenTimer = setInterval(() => {
        const raw = localStorage.getItem("tokenCountdownExpiresAt");
        const expiresAt = raw ? Number(raw) : 0;

        const remaining = Math.max(
          0,
          Math.ceil((expiresAt - Date.now()) / 1000)
        );
        this.tokenCountDown = remaining;

        if (remaining <= 0) {
          this._clearTokenTimer();
          localStorage.removeItem("tokenCountdownExpiresAt");
        }
      }, 1000);
    },

    _clearTokenTimer() {
      if (this._tokenTimer) {
        clearInterval(this._tokenTimer);
        this._tokenTimer = null;
      }
    },
  },
};
</script>
<style>
.cellphone-table td,
.cellphone-table th {
  padding: 4px 3px;
}
.change-cellphone {
  text-decoration: none;
  color: rgb(238, 134, 16);
  cursor: pointer;
}
.change-cellphone:hover {
  text-decoration: underline;
  text-underline-offset: 2px; /* opsional, bikin jarak dari teks */
}
.phone-number-input {
  border: 1px solid #888;
  padding: 0.5rem;
  width: 100%;
  outline: none;
  border-radius: 5px;
  font-size: 1.1rem;
  color: #555;
}
.phone-number-input:focus {
  border-color: #1d84c0;
}
.token--button {
  width: 100%;
}
.token--button .v-btn__content {
  font-size: 1em;
}

.cellphone-column {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  gap: 0 12px;
}

.cellphone-column span {
  color: rgb(17, 122, 184);
  font-weight: 600;
  font-size: 1.2rem;
}
small {
  font-size: 0.9rem;
}
</style>
